import Liveness from "./Liveness";
import LoadScriptFilesService from "../LoadScriptFilesService";
const PATH = 'static/selfie/liveness2d/';
const CHAVE = "9B4B55F4F8211046BDC7B2E8283ACB7AEA5C3C76B16FEC1E9600B7D767A4A4476847414442712FF07ADD377C5DCBE23F";

export default class Liveness2D extends Liveness{

    carregarArquivos(id) {
        let loadScript =  new LoadScriptFilesService();
        return loadScript.head_script(PATH+'tf.js', id, null, null)
            .then(() => loadScript.head_script(PATH+'tf-backend-wasm.js', id, null, null))
            .then(() => loadScript.head_script(PATH+'face-landmarks-detection@0.0.3.js', id, null, null))
            .then(() => loadScript.head_script(PATH+'brscan-sdk-selfie-liveness2d.min.js', id, 'high'));
    }

    preLoad() {
        window.selfie = new window.BrScanSDKSelfie.Selfie(CHAVE);
    }

    getRouteName() {
        return "Liveness2D";
    }

}



// WEBPACK FOOTER //
// ./src/services/liveness/Liveness2D.js